(function(Manogi, $, undefined) {
    
    //Private

    //Public
    
    Manogi.logout = function() {
        $.oc.stripeLoadIndicator.show();
        $(document).request('account::onLogout', {
            data: {
                
            },
            success: function(response) {
                window.location.reload();
            }
        });
    }

  

}( window.Manogi = window.Manogi || {}, jQuery ));